export default __webpack_public_path__ + "static/light-testimonial-bg-mobile-7e78d68a719a75c59d64d636d0aa59a0.svg";